import React, { useState, useEffect, MouseEvent } from 'react';
import { trackCustomEvent } from '../../utils/statistics/clientStatistics';
import { trackFavorite } from '../../utils/statistics/customEvents';
import { StyledFavoriteButton } from './FavoriteButton.styles';
import { ButtonTheme, ButtonType } from '../../ui-components/PlayButton/PlayButton';

type Props = {
    titleId: string;
    isFavorite: boolean;
    addFavorite: (favorite: any) => void;
    removeFavorite: (favorite: any) => void;
    setIsFavorite?: (i: boolean) => void;
    className?: string;
};

const FavoriteButton = ({
    titleId,
    isFavorite,
    addFavorite,
    removeFavorite,
    setIsFavorite = () => {},
    className,
}: Props) => {
    const [isClient, setIsClient] = useState<boolean>(false);
    const [triggerAnimation, setTriggerAnimation] = useState<boolean>(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    const handleFavoriteClick = (e: MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setTriggerAnimation(true);

        if (isFavorite) {
            removeFavorite(titleId);
            trackCustomEvent(trackFavorite(titleId, false));
            setIsFavorite(false);

            return;
        }

        addFavorite(titleId);
        trackCustomEvent(trackFavorite(titleId, true));
        setIsFavorite(true);
    };

    if (!isClient) {
        return (
            <StyledFavoriteButton role="button" data-rt="my-list-btn" buttonType={ButtonType.BUTTON} isHidden>
                Lägg till i Min lista
            </StyledFavoriteButton>
        );
    }

    return (
        <StyledFavoriteButton
            className={className}
            isFavorite={isFavorite}
            onClick={handleFavoriteClick}
            theme={ButtonTheme.DEFAULT}
            buttonType={ButtonType.BUTTON}
            aria-pressed={isFavorite}
            triggerAnimation={triggerAnimation}
            role="button"
            data-rt="my-list-btn"
        >
            {isFavorite ? 'Ta bort från Min lista' : 'Lägg till i Min lista'}
        </StyledFavoriteButton>
    );
};

export default FavoriteButton;
